import * as React from "react";
import type { SVGProps } from "react";
const SvgInformationCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#information-circle_svg__a)">
      <path d="M12 17c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v5c0 .55-.45 1-1 1" />
      <path d="M12 12h-2c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1M14 17h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1M12 9c-.13 0-.26-.03-.38-.08q-.18-.075-.33-.21-.135-.15-.21-.33A.84.84 0 0 1 11 8c0-.06 0-.13.02-.19.01-.07.03-.13.06-.19q.03-.09.09-.18c.03-.05.08-.1.12-.15q.15-.135.33-.21c.36-.16.81-.07 1.09.21.04.05.09.1.12.15q.06.09.09.18c.03.06.05.12.06.19.01.06.02.13.02.19 0 .13-.02.26-.08.38q-.075.18-.21.33c-.19.18-.45.29-.71.29" />
      <path d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10m0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8" />
    </g>
    <defs>
      <clipPath id="information-circle_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgInformationCircle;
